import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { ITrainingLevelLimit, ITrainingLevelLimitPatchItem } from './training-level-limits.model';

@Injectable({ providedIn: 'root' })
export class TrainingLevelLimitsApi {
  private readonly http = inject(HttpClient);

  private url(levelId: number): string {
    return `${environment.api}v2/athletes/training-levels/${levelId}/limits/`;
  }

  getLimits(levelId: number, sportId: number): Observable<ITrainingLevelLimit[]> {
    return this.http.get<ITrainingLevelLimit[]>(this.url(levelId), {
      params: new HttpParams().set('sport', sportId),
    });
  }

  /** Limits are editable only for custom training levels. Endpoint takes a bare array. */
  patchLimits(
    levelId: number,
    items: readonly ITrainingLevelLimitPatchItem[],
  ): Observable<ITrainingLevelLimit[]> {
    return this.http.patch<ITrainingLevelLimit[]>(this.url(levelId), items);
  }
}
